import React from 'react';

const InputText = (props) => {
    let requiredAsterisk = props.required
        ? <span className="text-danger">{props.required ? "*" : ""}</span>
        : "";

    return (
        <div className="form-group">
            <label htmlFor={props.name}>{props.label}</label> {requiredAsterisk}
            <input
                className="form-control"
                id={props.name}
                name={props.name}
                type="text"
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
                required={props.required}
            />
        </div>
    )
}

export default InputText;